"use client";

import { memo } from "react";
import { StreamdownWrapper } from "./streamdown-wrapper";
import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

type ResponseProps = ComponentProps<typeof StreamdownWrapper>;

export const Response = memo(
  ({ className, ...props }: ResponseProps) => (
    <StreamdownWrapper
      shikiTheme={["github-light", "github-dark"]}
      className={cn(
        "[&>*:first-child]:mt-0 [&>*:last-child]:mb-0 prose dark:prose-invert prose-sm w-full max-w-[700px]",
        className,
      )}
      {...props}
    >
      {props.children}
    </StreamdownWrapper>
  ),
  (prevProps, nextProps) => prevProps.children === nextProps.children,
);

Response.displayName = "Response";
